// extracted by mini-css-extract-plugin
export var excerpt = "styles-module--excerpt--+HbcV";
export var arrow = "styles-module--arrow--c4Q45";
export var wrapper = "styles-module--wrapper--rmSDM";
export var read_more = "styles-module--read_more--TWuyk";